import { useEffect, useState } from 'react';
import api from '../lib/api';

// Loads the public wellbeing knowledge (foundations, domains, topics) once.
export function useKnowledge() {
  const [data, setData] = useState({
    foundations: [],
    domains: [],
    topics: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [f, d, t] = await Promise.all([
          api.get('/knowledge/foundations'),
          api.get('/knowledge/domains'),
          api.get('/knowledge/topics?limit=300'),
        ]);
        if (!active) return;
        setData({
          foundations: f.data || [],
          domains: d.data || [],
          topics: (t.data && t.data.items) || [],
          loading: false,
          error: null,
        });
      } catch (e) {
        if (active) setData((s) => ({ ...s, loading: false, error: e.message }));
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return data;
}
